// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__2zMxT","lastUpdated":"PrivacyPolicy_lastUpdated__3qb4e"};